export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ReadingTime.vue?vue&type=template&id=b7b7539c&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ReadingTime.vue?vue&type=template&id=b7b7539c&scoped=true
// module id = 140
// module chunks = 0